import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Container } from '../../components/Layout';
import Title from '../../components/Header/parts/Title';

const AssetContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  form {
    position: absolute;
    z-index: -5;
    left: -150vw;
    opacity: 0;
    pointer-events: none;
  }
`;

const Asset = styled.div`
  flex-basis: 10%;
  display: inline-block;
  flex-grow: 1;
  flex-shrink: 1;
  position: relative;
  margin: 0;
  border: 2px solid var(--color-level-0);
  border-radius: 24px;
  transition: all 1s cubic-bezier(0, 1.5, 0.3, 0.8);
  overflow: hidden;
  button {
    cursor: copy;
    width: 100%;
    height: 100%;
    z-index: 10;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: ${props => props.color};
    padding: var(--size-space-tiny) var(--size-space-tiny);
    h6,
    p {
      pointer-events: none;
    }
    .label {
      display: block;
      width: 100%;
      text-align: center;
    }
    p {
      display: inline-block;
      width: auto;
      margin: 0 auto;
      font-size: 1.2rem;
      line-height: 2em;
      font-weight: 400;
      background-color: black;
      color: white;
      padding: 0 0.75em;
      margin-top: var(--size-space-tiny);
      border-radius: 4px;
    }
    h6 {
      margin: 0;
      padding: var(--size-space-small) var(--size-space-medium);
      border-radius: 24px;
      background-color: rgba(9, 10, 12, 0.56);
      opacity: 0;
      transform: translateY(40px);
      transition: all 0.1s ease-out;
    }
  }
  &:active,
  &:focus,
  &:hover {
    button h6 {
      opacity: 1;
    }
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p {
      opacity: 1;
      transform: translateY(0px);
    }
  }
  &:active,
  &:focus {
    transform: scale(0.9);
    transform: translateY(0px);
    transition: all 0.2s cubic-bezier(0, 1.5, 0.3, 0.8);
  }
`;

export function CopyColor({ name, value, valueContrast }) {
  const [copySuccess, setCopySuccess] = useState(name);
  const textAreaRef = useRef(null);

  function copyToClipboard(e) {
    textAreaRef.current.select();
    document.execCommand('copy');
    // This is just personal preference.
    // I prefer to not show the the whole text area selected.
    e.target.focus();
    setTimeout(function() {
      setCopySuccess(name);
    }, 2000);
    setCopySuccess('Copied!');
  }

  return (
    <Asset color={value}>
      <button onClick={copyToClipboard}>
        <h6>{copySuccess}</h6>
        <span className="label">
          <p>{value}</p>
        </span>
      </button>

      <form>
        <textarea ref={textAreaRef} value={value} readOnly />
      </form>
    </Asset>
  );
}

const AssetColor = ({ input }) => {
  return (
    <Container type="article" restrict>
      <Title
        title={input.primary.title.html}
        subtitle={input.primary.subtitle.html}
        description={input.primary.description.html}
        title_align={input.primary.align_text}
      />
      <h3>{input.primary.name}</h3>

      <AssetContainer>
        {input.items.map(({ name, value }, index) => {
          return (
            <CopyColor
              key={index + name + value}
              name={name}
              value={value}
              valueContrast={input.primary.value}
            />
          );
        })}
      </AssetContainer>
    </Container>
  );
};

export default AssetColor;

AssetColor.propTypes = {
  input: PropTypes.object.isRequired,
};

//src={x.file.localFile.childImageSharp.fluid}
//<Img fluid={x.image.localFile.childImageSharp.fluid} />
